import {
  FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_REQUEST,
  FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_SUCCESS,
  FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_FALUIRE,

  
} from './listAllDeletedTemplateTaskForProjectTypes';

const initialState = {
  loading: false,
  allDeletedTemplateTaskListForProject: null,  
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_REQUEST:
      return {
        ...state,
        loading: true,
      };  
     

    case FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_SUCCESS:
      return {
        ...state,
        allDeletedTemplateTaskListForProject: action.payload,
        error: '',
        loading: false,
      };

    case FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_FALUIRE:
      return {
        ...state,
        loading: false,
        allDeletedTemplateTaskListForProject: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
